import { AppError } from "@hisani/core";
import { PLANNER_ERROR_CODES } from "./contracts.js";
export function plannerError(code, message) {
    return new AppError({ code, message });
}
export function plannerConflict() {
    return plannerError(PLANNER_ERROR_CODES.conflict, "This draft changed elsewhere. Reload it before trying again.");
}
export function invalidPlannerTransition() {
    return plannerError(PLANNER_ERROR_CODES.invalidTransition, "The requested Condition Book transition is not allowed.");
}
